module.exports = __webpack_public_path__ + "static/media/food.425690fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/food.png
// module id = 211
// module chunks = 1